import gql from 'graphql-tag';

// Comments v3: a thread is done ("Erledigt", plan 1) or its change request applied/rejected (plan 3); editor level on the page.
export default gql`
mutation insertPageCommentResolution($commentId: Int!, $outcome: String!) {
  insert_page_comment_resolutions_one(object: {comment_id: $commentId, outcome: $outcome}) {
    comment_id
  }
}
`;
